module.exports = __webpack_public_path__ + "img/2-claim-triple-selection.1356fc5b.png";